<template>
	<div
		class="videoBox"
		id="homeid"
		v-show="monArr.length">
		<!-- 视频内容 -->
		<div class="shiping">
			<div
				class="parent-box"
				v-for="(item,index) in monArr"
				:key="'monArr' + index">
				<video
					v-if="item.url"
					class="videoa"
					autoplay="autoplay"
					controls="controls"
					:src="item.url">
				</video>
			</div>
		</div>
		<div class="video-arr video-arrL" @click="videoArrLClick" v-show="showVideoArrLClick"></div>
		<div class="video-arr video-arrR" @click="videoArrRClick" v-show="showVideoArrRClick"></div>
	</div>
</template>

<script>
// import Chart from "../echart/chart.vue";
// import SecondTitle from "../secondTitle.vue";
import {
	dataInterface
} from "@/api/dataInterfaceApi";

export default {
	data() {
		return {
			showVideoArrLClick: false,
			showVideoArrRClick: false,
			monArr: [],
			parentGongge: "",
			screenImg: require('@/assets/images/index/fullscreen.png'),
			a: 0,
			listQuery: {
				currentPage: 1,
				pageSize: 8,
				sort: 'desc'
			},
			totalPages: 0,
			number: 1,
			stationId: "0",
		};
	},
	components: {
		// Chart,
		// SecondTitle,
	},
    inject: ['cityUpdate'],
    computed: {
        computedProperty() {
        	return this.cityUpdate()
        }
    },
    watch: {
        computedProperty(val) {
			this.getData(val)
        },
    },
	mounted() {
		console.log('222222222222222222')
	},
	methods: {
		getData(data) {
			console.log('1111111111111111')
			if (data.stationId) {
				this.stationId = data.stationId;
				this.serchStreaming(data.stationId);
				// this.serchStreaming("0");//调试
			} else {
				this.serchStreaming("0");
			}
		},

		// 查询返回的直播流
		serchStreaming(stationId) {
			var params = {
				id: stationId,
				pageSize: this.listQuery.pageSize,
				currentPage: this.listQuery.currentPage
			}
			dataInterface
				.gclVideoLiveInfo(params)
				.then((res) => {
					if (!res) return;
					console.log('查询到的直播流数据', res)
					// this.total = res.data.total
					this.monArr = res.records;
					console.log(res.records.length)
					if (this.listQuery.currentPage < res.pages) {
						this.showVideoArrRClick = true;
					} else {
						this.showVideoArrRClick = false;
					}
					this.totalPages = res.pages;
					// if (this.activeIndex == 2) {
					if (this.monArr.length != 0 && this.monArr.length < 8) {
						let num = Number(8) - Number(this.monArr.length)
						let str = {
							url: ''
						}
						for (var t = 0; t < num; t++) {
							this.monArr.push(str)
						}
					}
					// }

					// if (this.activeIndex == 1) {
					//   if (this.monArr.length < 4) {
					//     let num = Number(4) - Number(this.monArr.length)
					//     let str = { url: '' }
					//     for (var t = 0; t < num; t++) {
					//       this.monArr.push(str)
					//     }
					//   }
					// }
					// if (this.dataId.id != "0") {
					//   clearTimeout(this.timer)
					// }
					// console.log('处理之后的数据', this.monArr)
				})
				.catch((err) => {
					console.log(err);
				});
		},

		fullScreenClick() {
			this.a++
			this.a % 2 == 1 ? this.enterfullscreen() : this.exitfullscreen()
			if (this.a % 2 == 1) {
				this.screenImg = require('@/assets/images/index/fullscreen-exit.png');
				// this.parentGongge = "grid-template-columns: repeat(3, 33%);grid-template-rows: repeat(2, 33%);";
			} else {
				this.screenImg = require('@/assets/images/index/fullscreen.png');
				// this.parentGongge = "grid-template-columns: repeat(3, 33%);grid-template-rows: repeat(2, 33%);";
			}
		},
		//控制全屏
		enterfullscreen() { //进入全屏
			var docElm = document.getElementById('homeid') // 指定容器id
			//W3C
			if (docElm.requestFullscreen) {
				docElm.requestFullscreen()
			}
			//FireFox
			else if (docElm.mozRequestFullScreen) {
				docElm.mozRequestFullScreen()
			}
			//Chrome等
			else if (docElm.webkitRequestFullScreen) {
				docElm.webkitRequestFullScreen()
			}
			//IE11
			else if (elem.msRequestFullscreen) {
				elem.msRequestFullscreen()
			}
		},
		//退出全屏
		exitfullscreen() {
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen()
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen()
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen()
			}
		},
		//点击左边
		videoArrLClick() {
			// this.showVideoArrRClick = true;
			if (this.number != 1) {
				this.number--;
				this.listQuery.currentPage = this.number;
				this.showVideoArrLClick = true;
				this.serchStreaming(this.stationId);
				if (this.listQuery.currentPage == 1) {
					this.showVideoArrLClick = false;
				}
			}
		},
		//点击右边
		videoArrRClick() {
			this.showVideoArrLClick = true;
			if (this.number < this.totalPages) {
				this.number++;
				this.listQuery.currentPage = this.number;
				// this.showVideoArrRClick = true;
				this.serchStreaming(this.stationId);
				if (this.listQuery.currentPage == this.totalPages) {
					this.showVideoArrRClick = false;
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.videoBox {
	position: relative;
	flex: 1;
	.shiping {
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		.parent-box {
			width: 25%;
			height: 50%;
			background-image: url("~@/assets/images/index/available.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			padding: 3px;
			.videoa {
				width: 100%;
				height: 100%;
				object-fit: fill;
			}
		}
		// .parent {
		// 	display: grid;
		// 	width: 100%;
		// 	justify-content: space-evenly;
		// 	align-content: space-evenly;
		// 	display: flex;
		// 	flex-wrap: wrap;
		// 	// 4宫格
		// 	// grid-template-columns: repeat(2, 49%);
		// 	// grid-template-rows: repeat(2, 49%);
		// 	// 9宫格
		// 	grid-template-columns: repeat(3, 33%);
		// 	// grid-template-rows: repeat(2, 33%);
		// 	// 1宫格
		// 	// grid-template-columns: repeat(1, 100%);
		// 	// grid-template-rows: repeat(1, 100%);
		// 	//       grid-template-columns: 410px 410px 410px;
		// 	//grid-template-rows: 232px 232px;
		// 	grid-template-rows: 260px 260px;

		// 	// justify-content: space-between;
		// }
	}

	.fenye {
		height: 50px;
	}
}

.video-arr {
	position: absolute;
	width: 24px;
	height: 45px;
	background: url('~@/assets/images/index/arrow_left.png');
	background-size: 100% 100%;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
}

.video-arrL {
	left: 0px;
}

.video-arrR {
	background: url('~@/assets/images/index/arrow_right.png');
	background-size: 100% 100%;
	right: 0px;
}
</style>